/**
 * Created by spepa on 03.09.2024
 */

const PassHeaderPack = cc.Node.extend({
    ctor: function (offer, options) {
        this._super();
        this.setAnchorPoint(0.5, 0.5);
        this.offer = offer;
        this.options = options;

        this.createPackAnimation();
    },

    createPackAnimation: function () {
        const styles = cleverapps.styles.PassHeaderPack[this.offer.type] || cleverapps.styles.PassHeaderPack;

        const pack = new cleverapps.Spine(this.options.pack_json);
        pack.setAnimation(0, "animation", true);
        this.addChild(pack);
        this.setContentSize(pack.getContentSize());
        pack.setAlignment(this.width / 2, this.height / 2);

        const badge = new PassPackBadge(this.offer);
        pack.addChild(badge);
        badge.setAlignment(styles.badge);

        const packOnClick = function () {
            cleverapps.offerManager.showOfferWindow(this.offer);
            this.options.close();
        }.bind(this);
        cleverapps.UI.onClick(pack, packOnClick);
        cleverapps.UI.onClick(badge, packOnClick);
        cleverapps.UI.applyHover(pack);
    }
});

cleverapps.styles.PassHeaderPackTemplate = {
    badge: {
        x: { align: "right", dx: 141 },
        y: { align: "center", dy: 11 }
    }
};

cleverapps.styles.PassHeaderPack = cleverapps.overrideStyles(cleverapps.styles.PassHeaderPackTemplate, {}, true);
